import React from "react";
import { stats } from "../mock";
import { useLanguage } from "../contexts/LanguageContext";

const Stats = () => {
  const { t } = useLanguage();

  return (
    <section className="mag-stats">
      <div className="mag-stats-inner">
        {stats.map((stat) => (
          <div key={stat.id} className="reveal">
            <div className="mag-stat-value">{stat.value}</div>
            <div className="mag-stat-label">{t.stats[stat.key]}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
